/* global femcare */

/**
 * Central gateway for analytics data-layer events.
 */
femcare.tracking.analytics = {
    legacyEvents: ['gaEvent', 'addToCart', 'removeFromCart'],
    /**
     * Returns the global data layer.
     * @returns {Array<object>} Global data layer.
     */
    getDataLayer () {
        window.dataLayer = window.dataLayer || [];
        return window.dataLayer;
    },

    /**
     * Checks whether a payload uses the legacy Universal Analytics format.
     * @param {object} payload - Analytics payload.
     * @returns {boolean} Whether the payload is legacy.
     */
    isLegacyEvent (payload) {
        return !payload || this.legacyEvents.indexOf(payload.event) !== -1 ||
            Object.prototype.hasOwnProperty.call(payload, 'eventCategory') ||
            Object.prototype.hasOwnProperty.call(payload, 'eventAction') ||
            Object.prototype.hasOwnProperty.call(payload, 'eventLabel');
    },

    /**
     * Pushes an analytics payload to the data layer.
     * @param {object} payload - Analytics payload.
     * @returns {boolean} Whether the payload was pushed.
     */
    push (payload) {
        if (this.isLegacyEvent(payload)) {
            return false;
        }

        this.getDataLayer().push(payload);
        return true;
    },

    /**
     * Pushes a custom analytics event.
     * @param {string} eventName - Event name.
     * @param {object} [data] - Event data.
     * @returns {boolean} Whether the event was pushed.
     */
    pushEvent (eventName, data) {
        const payload = { event: eventName };

        if (data) {
            payload.ga4_data = data;
        }

        return this.push(payload);
    },

    /**
     * Pushes an ecommerce analytics event.
     * @param {string} eventName - Event name.
     * @param {object} ecommerce - Ecommerce data.
     * @param {object} [parameters] - Additional event parameters.
     * @returns {boolean} Whether the event was pushed.
     */
    pushEcommerce (eventName, ecommerce, parameters) {
        const payload = Object.assign({}, parameters, { event: eventName, ecommerce });
        this.getDataLayer().push({ ecommerce: null });
        return this.push(payload);
    },

    /**
     * Gets analytics data rendered by the backend.
     * @param {string} property - Property to match.
     * @param {string} value - Value to match.
     * @returns {object|null} Configured analytics data.
     */
    getConfiguredData (property, value) {
        const matches = femcare.shared.util.getEntryFromObject(window.gaDataLayer || [], property, value);
        return matches && matches.length && matches[0].Data ? matches[0].Data : null;
    },

    /**
     * Pushes an event using data rendered by the backend.
     * @param {string} eventId - Event ID.
     * @param {string} eventName - Event name.
     * @param {boolean} isEcommerce - Whether the event contains ecommerce data.
     * @returns {boolean} Whether the event was pushed.
     */
    pushConfiguredEvent (eventId, eventName, isEcommerce) {
        const data = this.getConfiguredData('Id', eventId);
        if (!data) {
            return false;
        }

        return isEcommerce ? this.pushEcommerce(eventName, { items: [data] }) : this.pushEvent(eventName, data);
    }
};
